/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'
import Select from 'react-select'
import _ from 'lodash'

class ItemField extends React.PureComponent {
  render() {
    const { onChange, selectedRestaurant, itemOptions, value } = this.props

    return (
      <Form.Field required>
        <label>Items</label>
        <Select
          required
          menuPlacement="bottom"
          isDisabled={selectedRestaurant === null}
          isSearchable
          placeholder="Please choose items"
          onChange={res => onChange(res.value)}
          options={itemOptions}
          defaultValue={_.find(itemOptions, item => item.value === value)}
        />
      </Form.Field>
    )
  }
}

export default ItemField



// WEBPACK FOOTER //
// ./src/components/specialDeal/fields/itemField.js